<template>
    <div class="program-cta-wraper">
        <div class="section-static">
            <div class="mt-auto mb-auto mt-xxl-0">
                <h5
                    v-if="globals.formationTabsTitleSections.formationsCta.sectionTitle"
                    class="text-white mb-4 mb-xxl-5"
                >
                    {{ globals.formationTabsTitleSections.formationsCta.sectionTitle }}
                </h5>

                <router-link
                    v-if="globals.formationTabsTitleSections.formationsCta.buttonLink"
                    class="button"
                    :to="{ path: globals.formationTabsTitleSections.formationsCta.buttonLink.data.fr }"
                    itemtype="https://www.schema.org/SiteNavigationElement"
                >
                {{ globals.formationTabsTitleSections.formationsCta.buttonLink.customText }}
                </router-link>
            </div>
        </div>

        <div class="section-animate">
            <input
                class="section-controler section-controler-01"
                type="radio"
                checked
                name="cta-section-input"
                id="sec01"
            />
            <label
                for="sec01"
                v-if="globals.formationTabsTitleSections.formationsCta.section01Img.url"
                class="cta-section section-01 bg-img"
                :style="{
                    backgroundImage: `url(${globals.formationTabsTitleSections.formationsCta.section01Img.url})`,
                }"
            >
                <div class="section-number">
                    <h3 class="number">{{ $t('01') }}</h3>
                </div>
                <div class="overlay">
                    <i class="fa-regular fa-arrow-right fa-3x arrow-icon"></i>
                </div>
                <div class="content">
                    <div class="mt-auto">
                        <h4>
                            {{ globals.formationTabsTitleSections.formationsCta.section01Title }}
                        </h4>
                        <p class="mb-0">
                            {{ globals.formationTabsTitleSections.formationsCta.section01Text }}
                        </p>
                    </div>
                </div>
            </label>
            <input
                class="section-controler section-controler-02"
                type="radio"
                name="cta-section-input"
                id="sec02"
            />
            <label
                for="sec02"
                v-if="globals.formationTabsTitleSections.formationsCta.section02Img.url"
                class="cta-section section-02 bg-img"
                :style="{
                    backgroundImage: `url(${globals.formationTabsTitleSections.formationsCta.section02Img.url})`,
                }"
            >
                <div class="section-number">
                    <h3 class="number">{{ $t('02') }}</h3>
                </div>
                <div class="overlay">
                    <i class="fa-regular fa-arrow-right fa-3x arrow-icon"></i>
                </div>
                <div class="content">
                    <div class="mt-auto">
                        <h4>
                            {{ globals.formationTabsTitleSections.formationsCta.section02Title }}
                        </h4>
                        <p class="mb-0">
                            {{ globals.formationTabsTitleSections.formationsCta.section02Text }}
                        </p>
                    </div>
                </div>
            </label>
            <input
                class="section-controler section-controler-03"
                type="radio"
                name="cta-section-input"
                id="sec03"
            />
            <label
                for="sec03"
                v-if="globals.formationTabsTitleSections.formationsCta.section03Img.url"
                class="cta-section section-03 bg-img"
                :style="{
                    backgroundImage: `url(${globals.formationTabsTitleSections.formationsCta.section03Img.url})`,
                }"
            >
                <div class="section-number">
                    <h3 class="number">{{ $t('03') }}</h3>
                </div>
                <div class="overlay">
                    <i class="fa-regular fa-arrow-right fa-3x arrow-icon"></i>
                </div>
                <div class="content">
                    <div class="mt-auto">
                        <h4>
                            {{ globals.formationTabsTitleSections.formationsCta.section03Title }}
                        </h4>
                        <p class="mb-0">
                            {{ globals.formationTabsTitleSections.formationsCta.section03Text }}
                        </p>
                    </div>
                </div>
            </label>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'FormationCta',
    components: {
        // AssetLoader
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
